<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useSlotsManagementStore } from '../../model/slots-management/store'
import { useBookingSlotsSave } from '../../api/slots-management/booking.hook'
import BookingSlotsTable from './BookingSlotsTable.vue'
import SlotsDaysHeader from '../slots/SlotsDaysHeader.vue'

defineOptions({
  name: 'BookingSlotsSection',
})

const store = useSlotsManagementStore()

const refTabs = computed(() => store.getBookingDays.map(day => ({
  id: day.day_of_week,
  point: day.slots.some(slot => slot.enable_slot),
})))

const save = (): void => {
  void useBookingSlotsSave()
}
</script>

<template>
  <CardAdmin
    title="Booking slots management"
    fullwidth
  >
    <template #header>
      <BtnPrimary
        text="Save"
        color="emerald"
        :disabled="store.isSaving"
        @click="save"
      />
    </template>
    <SlotsDaysHeader
      :tabs="refTabs"
      :selected="store.getDayTabId"
      @select="store.setDayTabId"
    />
    <BookingSlotsTable
      v-for="day in store.getBookingDays"
      :key="day.day_of_week"
      :day="day"
      :show="day.day_of_week === store.getDayTabId"
    />
  </CardAdmin>
</template>
